import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_CUSTOMER } from "../customer.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateCustomerInput } from "../../../__generated__/globalTypes";
import {
  CreateCustomerMutation,
  CreateCustomerMutationVariables,
} from "../../../__generated__/CreateCustomerMutation";

interface IProps {
  defaultValues: DeepPartial<CreateCustomerInput>;
  onCompleted: () => any;
}

export const useCreateCustomer = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateCustomerInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateCustomerMutation,
    CreateCustomerMutationVariables
  >(CREATE_CUSTOMER, {
    refetchQueries: ["CustomersQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createCustomer?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createCustomer?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
